import React from 'react';
import PropTypes from 'prop-types';
import * as styles from '../components/ui/Body/Body.module.scss';
import RelatedSubjectMatter from '../components/Layouts/RelatedSubjectMatter/RelatedSubjectMatter';

const RelatedSubjectMatterSlice = ({
  input: {
    primary: {
      heading,
    },
    items,
  },
}) => (
  <div className={styles.content}>
    <RelatedSubjectMatter
      heading={heading}
      links={items}
    />
  </div>
);

RelatedSubjectMatterSlice.propTypes = {
  input: PropTypes.shape({
    primary: PropTypes.object,
    items: PropTypes.array,
  }).isRequired,
};

export default RelatedSubjectMatterSlice;
